module.exports = __webpack_public_path__ + "img/bank-counter-bg-en.721117a2.png";